<template>
  <v-container fluid grid-list-lg>
    <v-card :loading="loading" outlined>
      <v-toolbar dense flat :color="$style.purchase.titlebar">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title> Order List </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout row wrap justify-end class="mb-1">
          <v-flex shrink>
            <v-btn
              @click="add"
              outlined
              rounded
              :icon="$vuetify.breakpoint.xsOnly"
              v-if="checkRightStatus(78)"
              raised
              small
            >
              <v-icon small>add</v-icon>
              <span v-if="!$vuetify.breakpoint.xsOnly">New</span>
            </v-btn>
          </v-flex>
          <v-flex shrink v-if="hasRunningOrder">
            <v-btn
              @click="openRunning"
              outlined
              :icon="$vuetify.breakpoint.xsOnly"
              class="ml-2"
              rounded
              small
            >
              <v-icon small>mdi-history</v-icon>
              <span v-if="!$vuetify.breakpoint.xsOnly">Running Order</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar>

      <v-toolbar dense elevation="0" v-if="!$vuetify.breakpoint.xsOnly">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search"
          single-line
          style="min-width: 250px"
          hide-details
          clearable
        ></v-text-field>

        <v-divider vertical class="mx-1"></v-divider>

        <v-btn-toggle
          v-model="orderStatus"
          @change="getList()"
          color="deep-purple accent-3"
          small
          group
        >
          <v-btn value="all">
            <span>All</span>
          </v-btn>
          <v-btn value="pending">
            <span>Pending</span>
          </v-btn>

          <v-btn value="completed">
            <span>Completed</span>
          </v-btn>
        </v-btn-toggle>

        <v-spacer></v-spacer>

        <DateTimePicker
          :defaultRange="defaultRange"
          :range="true"
          :hideTime="true"
          v-model="dateTime"
          @submit="getList()"
        />
      </v-toolbar>

      <v-toolbar v-else dense flat elevation="0">
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          icon
          class="filter-toolbar__mobile-trigger"
          @click="mobileFilterSheet = true"
        >
          <v-icon>mdi-tune-variant</v-icon>
        </v-btn>
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>

      <v-bottom-sheet
        v-show="$vuetify.breakpoint.smAndDown"
        v-model="mobileFilterSheet"
        inset
        max-width="520"
      >
        <v-card>
          <v-toolbar dense flat elevation="0">
            <v-btn icon @click="mobileFilterSheet = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="subtitle-2">Filters</span>
          </v-toolbar>
          <v-card-text>
            <v-btn-toggle
              v-model="orderStatus"
              @change="getList()"
              color="deep-purple accent-3"
              group
              class="mobile-status-toggle"
            >
              <v-btn value="all">All</v-btn>
              <v-btn value="pending">Pending</v-btn>
              <v-btn value="completed">Completed</v-btn>
            </v-btn-toggle>
            <v-divider class="my-2"></v-divider>
            <DateTimePicker
              :defaultRange="defaultRange"
              :range="true"
              :hideTime="true"
              v-model="dateTime"
              @submit="getList()"
            />
            <v-btn
              block
              color="primary"
              text
              class="mt-2"
              @click="mobileFilterSheet = false"
            >
              Close
            </v-btn>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>

      <v-card-text>
        <!-- <v-data-table :headers="headers" :items="Invoices" :search="search" :loading="loading"
          @current-items="updateTotal" :sort-by="sortBy" sort-desc :page.sync="page" :items-per-page="itemsPerPage"> -->
        <v-data-table
          :headers="headers"
          :items="Invoices"
          :search="search"
          :loading="loading"
          :sort-by="sortBy"
          sort-desc
          :options.sync="options"
          :server-items-length="totalItems"
          @current-items="updateTotal"
          :custom-filter="customSearch"
          :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left" @click="viewOrder(item)">
                {{ item.date | moment("MM/DD/YYYY hh:mm a") }}
              </td>
              <td class="text-left" @click="viewOrder(item)">
                <span>{{ item.localId }} </span>
                <!-- <v-chip
                  v-if="item.isRemoteOrder"
                  color="green lighten-3"
                  small
                  text-color="green darken-4"
                  >Online</v-chip
                > -->
                <v-chip
                  color="green lighten-3"
                  small
                  class="ml-1 font-weight-bold"
                  v-if="item.isRemoteOrder"
                  text-color="green darken-4"
                  >Online</v-chip
                >
                <v-chip
                  color="indigo lighten-4"
                  small
                  class="ml-1 font-weight-bold"
                  v-if="item.isChocoOrder"
                  text-color="#3D6BFF"
                  >CHOCO</v-chip
                >
              </td>
              <td class="text-left" v-if="!CustomerId" @click="viewOrder(item)">
                <div v-if="item.Customer">{{ item.Customer.name }}</div>
                <div v-else>
                  {{ item.metadata.name }}
                  <v-chip small>Unknown Customer</v-chip>
                </div>
              </td>

              <td class="text-right" @click="viewOrder(item)">
                {{ item.total | currency }}
              </td>
              <td class="text-left">
                <v-chip
                  color="green lighten-4"
                  small
                  v-if="item.completeDate"
                  text-color="green darken-4"
                  >Completed</v-chip
                >
                <v-chip
                  color="deep-orange lighten-3"
                  small
                  v-else
                  text-color="deep-orange darken-4"
                  >Pending</v-chip
                >
              </td>
              <td class="text-left" @click="viewOrder(item)">
                {{ item.completeDate | moment("MM/DD/YYYY hh:mm a") }}
              </td>
              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="!CustomerId" @click="viewProfile(item)">
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!CustomerId"> </v-divider>
                    <v-list-item @click="viewOrder(item)">
                      <v-list-item-title>View Order</v-list-item-title>
                    </v-list-item>
                    <v-divider> </v-divider>
                    <v-list-item
                      v-if="!item.completeDate"
                      @click="editOrder(item)"
                    >
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteOrder(item)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!item.completeDate"></v-divider>
                    <v-list-item
                      :disabled="item.Customer && item.Customer.blockOrder"
                      v-if="!item.completeDate"
                      @click="convertToInvoice(item)"
                    >
                      <v-list-item-title>
                        <div>Convert to invoice</div>
                        <div
                          class="mt-1"
                          v-if="item.Customer && item.Customer.blockOrder"
                        >
                          <v-chip small color="red" text-color="white"
                            >Blocked</v-chip
                          >
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="openHistory(item)">
                      <v-list-item-title>View History</v-list-item-title>
                    </v-list-item>
                    <!-- <OrderViewLink :OrderId="item.id" /> -->
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
          <template v-slot:body.append="{ headers }" v-if="Invoices.length > 0">
            <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td
                :colspan="headers.length - 3"
                class="text-right font-weight-bold"
              >
                List Total
              </td>

              <td class="text-right font-weight-bold">
                {{ total | currency }}
              </td>
              <td :colspan="2"></td>
            </tr>
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td
                :colspan="headers.length - 3"
                class="text-right font-weight-bold"
              >
                Result Total
              </td>

              <td class="text-right font-weight-bold">
                {{ fullTotal | currency }}
              </td>
              <td :colspan="2"></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <OrderHistoryDialog
      v-show="historyDialog"
      v-model="historyDialog"
      :order="historyOrder"
    />
  </v-container>
</template>

<script>
import orderService from "../service";
const DateTimePicker = () => import("@/components/DateTimePicker");
import OrderHistoryDialog from "@/modules/Order/InHouse/components/OrderHistoryDialog.vue";
// import OrderViewLink from "./OrderViewLink";
import { mapGetters } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  props: {
    CustomerId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    due: {
      default: false,
    },
  },
  name: "order-list",
  data() {
    return {
      historyDialog: false,
      historyOrder: null,
      totalItems: 0,
      mobileFilterSheet: false,
      hasRunningOrder: false,
      defaultRange: "since90DaysAgo",
      orderStatus: "all",
      fullTotal: 0,
      total: 0,
      dateTime: {
        start: this.$moment()
          .subtract(90, "days")
          .startOf("day")
          .format("YYYY-MM-DD"),
        end: this.$moment().endOf("day").format("YYYY-MM-DD"),
      },
      createDialog: false,
      count: null,
      selectedPayee: null,
      headers: [],
      Invoices: [],
      search: null,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      sortBy: "localId",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  watch: {
    CustomerId: {
      immediate: true,
      handler() {
        this.getList();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getList();
      },
    },
  },
  created() {
    const draft = localStorage.getItem("runningOrder");
    if (draft) {
      try {
        const parsed = JSON.parse(draft);
        if (parsed?.Order?.OrderDetails?.length > 0) {
          this.hasRunningOrder = true;
        }
      } catch (e) {
        // fallback — invalid JSON, clear it
        localStorage.removeItem("runningOrder");
      }
    }
    this.loadHeader();
    document.title = "smplsale - Order List";
    // this.getList();
  },
  components: {
    DateTimePicker,
    OrderHistoryDialog
    // OrderViewLink,
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
    // hasInvoiceViewLimit() {
    //   if (this.currentBusiness.metadata) {
    //     return (
    //       this.currentBusiness &&
    //       this.currentBusiness.metadata &&
    //       this.currentBusiness.metadata.invoiceViewLimit
    //     );
    //   } else {
    //     return true;
    //   }
    // },
    // defaultRange() {
    //   if (
    //     this.currentBusiness.metadata &&
    //     this.currentBusiness.metadata.invoiceViewLimit
    //   ) {
    //     return this.currentBusiness.metadata.invoiceViewLimit.range;
    //     // return this.hasInvoiceViewLimit ? this.currentBusiness.metadata.invoiceViewLimit.range : 'since15DaysAgo';
    //   } else {
    //     return "since15DaysAgo";
    //   }
    // },
  },
  methods: {
    customSearch(value, search, item) {
      // Normalize and lowercase search term
      search = search.toString().toLowerCase();

      // Search in customer name if it exists
      const customerName = item.Customer?.name?.toLowerCase() || "";

      // Search in metadata name if customer is not present
      const metadataName = item.metadata?.name?.toLowerCase() || "";

      // Also match against other fields like localId or total if needed
      const localId = item.localId?.toString() || "";
      const total = item.total?.toString() || "";

      return (
        customerName.includes(search) ||
        metadataName.includes(search) ||
        localId.includes(search) ||
        total.includes(search)
      );
    },
    convertToInvoice(order) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to convert this order to invoice?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          orderService
            .getById(order.id)
            .then((obj) => {
              const passData = obj.data;

              this.$router.push({
                name: "invoice-create",
                params: { passData: passData, type: "order" },
              });

              // console.log("test consver purchase", obj);
            })
            .catch((err) => {
              // console.log("got error", err);
            });
        }
      });
    },
    updateTotal(val) {
      this.total = 0;
      val.map((row) => {
        this.total += row.total;
      });
    },
    openHistory(order) {
      if (!this.currentBusiness.metadata.historyTracking) {
        this.$swal({
          icon: "warning",
          title: "History Tracking Off",
          text: "Enable it in Settings to view change logs ($50/month).",
        });
        return;
      }
      this.historyOrder = order;
      this.historyDialog = true;
    },
    openRunning() {
      if (this.CustomerId) {
        this.$router.push({
          path: `/order/create?CustomerId=${this.CustomerId}`,
        });
      } else {
        this.$router.push({ path: "/order/create" });
      }
    },

    add() {
      if (this.hasRunningOrder) {
        this.$swal({
          title: "Are you sure?",
          text: "There is a running order. Do you want to clear it?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            localStorage.removeItem("runningOrder");
            this.goToCreateOrder();
          }
          // else do nothing, user canceled
        });
      } else {
        this.goToCreateOrder();
      }
    },
    resumeOrder() {
      const draft = localStorage.getItem("runningOrder");

      if (!draft) {
        this.$swal({
          icon: "info",
          title: "No running order found",
          text: "It looks like there's no saved order to resume.",
          confirmButtonText: "Okay",
        });
        return;
      }

      try {
        const parsed = JSON.parse(draft);
        if (parsed?.Order?.CustomerId) {
          this.$router.push({
            path: `/order/create?CustomerId=${parsed.Order.CustomerId}`,
          });
        } else {
          this.$router.push({ path: "/order/create" });
        }
      } catch (e) {
        console.error("⚠️ Failed to parse running order from localStorage", e);
        localStorage.removeItem("runningOrder");

        this.$swal({
          icon: "error",
          title: "Something went wrong",
          text: "Your saved order couldn't be resumed.",
          confirmButtonText: "Okay",
        });
      }
    },
    goToCreateOrder() {
      if (this.CustomerId) {
        this.$router.push({
          path: `/order/create?CustomerId=${this.CustomerId}`,
        });
      } else {
        this.$router.push({ path: "/order/create" });
      }
    },
    viewProfile(val) {
      this.$router.push({ path: `/customer/${val.CustomerId}/profile` });
    },
    viewOrder(order) {
      const hashId = hashids.encode(order.id);
      // // console.log('hashId', hashId)
      const routeData = this.$router.resolve({
        path: `/global/order/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    loadHeader() {
      this.headers = [];
      this.headers.push({
        text: "Date",
        align: "left",
        value: "date",
        sortable: true,
      });

      this.headers.push({
        text: "Order Number",
        align: "left",
        value: "localId",
        sortable: true,
      });

      if (!this.CustomerId) {
        this.headers.push({
          text: "Customer Name",
          value: "Customer.name",
          align: "left",
          sortable: true,
        });
      }

      this.headers.push({
        text: "Total",
        value: "total",
        align: "right",
        sortable: true,
      });

      this.headers.push({
        text: "Status",
        value: "status",
        align: "right",
        sortable: false,
      });

      this.headers.push({
        text: "Complete Date",
        align: "left",
        value: "completeDate",
        sortable: true,
      });

      this.headers.push({
        text: "",
        value: "action",
        sortable: false,
      });
    },
    // getList() {
    //   this.loading = true;
    //   let where = {};
    //   if (!this.showAll) {
    //     where = {
    //       start: this.dateTime.start,
    //       end: this.dateTime.end,
    //     };
    //   }
    //   if (this.CustomerId) {
    //     where.CustomerId = this.CustomerId;
    //   }

    //   if (!this.currentUser.isAdmin && this.checkRightStatus(50)) {
    //     where.assingedCustomer = this.currentUser.id;
    //   }

    //   if (this.orderStatus === "pending") {
    //     where.pending = true;
    //   }
    //   if (this.orderStatus === "completed") {
    //     where.completed = true;
    //   }

    //   if (this.orderStatus === "all") {
    //     delete where.completed;
    //     delete where.pending;
    //   }

    //   if (this.orderStatus && this.orderStatus !== "all") {
    //     where.status = this.orderStatus;
    //   }

    //   return orderService
    //     .getAll(where)
    //     .then((response) => {
    //       console.log("response", response);
    //       const cnt = Number(response?.count) || 0;

    //       this.totalItems = cnt;

    //       this.loading = false;
    //       this.Invoices = response.data;
    //       this.fullTotal = 0;
    //       this.Invoices.map((row) => {
    //         this.fullTotal += row.total;
    //       });
    //       this.count = response.count;
    //       return response;
    //     })
    //     .catch(() => {
    //       // console.log("error", err);
    //     });
    // },
    getList() {
      this.loading = true;

      let where = {};

      if (!this.showAll) {
        where.start = this.dateTime.start;
        where.end = this.dateTime.end;
      }

      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }

      if (!this.currentUser.isAdmin && this.checkRightStatus(50)) {
        where.assingedCustomer = this.currentUser.id;
      }

      if (this.orderStatus === "pending") {
        where.pending = true;
      }

      if (this.orderStatus === "completed") {
        where.completed = true;
      }

      if (this.orderStatus === "all") {
        delete where.completed;
        delete where.pending;
      }

      if (this.orderStatus && this.orderStatus !== "all") {
        where.status = this.orderStatus;
      }

      // Pagination + sorting
      where.limit = this.options?.itemsPerPage || 10;
      where.offset =
        (this.options?.page - 1) * (this.options?.itemsPerPage || 10);

      if (this.options.sortBy?.length > 0) {
        where.sortBy = this.options.sortBy[0];
        where.sortDesc = this.options.sortDesc?.[0];
      }

      return orderService
        .getAll(where)
        .then((response) => {
          this.loading = false;
          this.Invoices = response.data || [];
          this.totalItems = Number(response.count || 0);
          this.fullTotal = Number(response.totals?.total || 0);
          return response;
        })
        .catch((err) => {
          this.loading = false;
          console.error("Order list fetch failed", err);
        });
    },
    editOrder(order) {
      this.$router.push({ path: `/order/${order.id}/edit` });
    },
    deleteOrder(order) {
      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.deletePrecaution
      ) {
        this.$swal
          .fire({
            title: "Are you sure?",
            html: `You won't be able to revert this.</br> <div style="color:red;">Type <span style="font-weight: bold">delete</span> in order remove this</div>`,
            icon: "question",
            input: "text",
            inputAttributes: {
              autocapitalize: "off",
            },
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
          })
          .then((result) => {
            if (result.value && result.value === "delete") {
              orderService.delete(order.id).then((response) => {
                if (response.data) {
                  this.$swal("Deleted!", "Order has been deleted.", "success");
                  this.getList();
                }
              });
            } else if (result.dismiss === "cancel") {
            } else {
              this.$swal("Delete", 'Type "delete" to delete item', "error");
            }
          });
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            orderService.delete(order.id).then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Order has been deleted.", "success");
                this.getList();
              }
            });
          }
        });
      }
    },
  },
};
</script>
